import { useState } from "react";

import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import { useNavigate } from "react-router-dom";

import useAxios from "@hooks/use-axios";
import { ONBOARD_STEPS, onboardBrandDefaults, onboardBrandSchema } from "./schema";

const useOnboardBrand = () => {

    const navigate = useNavigate();
    const { axiosInstance, loading } = useAxios({ base: "ops" });
    const [activeStep, setActiveStep] = useState(0);
    const isLastStep = activeStep === ONBOARD_STEPS.length - 1;

    const methods = useForm({
        resolver     : yupResolver(onboardBrandSchema),
        defaultValues: onboardBrandDefaults
    });

    const submitBrand = methods.handleSubmit(async (data) => {
        await axiosInstance.post("accounts/v1", {
            name                : data.name,
            country             : data.country,
            payment_model       : data.payment_model,
            debit_note_frequency: data.debit_note_frequency,
            platform_name       : data.platform_name,
            kyc_window          : Number(data.kyc_window),
            smtp_configured     : Boolean(data.smtp_host)
        });
        navigate("/brands");
    });

    const goNext = async () => {
        if (isLastStep) {
            await submitBrand();
            return;
        }
        const isStepValid = await methods.trigger(ONBOARD_STEPS[activeStep].fields);
        if (isStepValid) setActiveStep((step) => step + 1);
    };

    const goBack = () => setActiveStep((step) => Math.max(0, step - 1));

    return { methods, activeStep, isLastStep, goNext, goBack, loading };
};

export default useOnboardBrand;
